export function SkipToContent() {
  return (
    <a
      href="#main-content"
      className="sam-skip-to-content sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[9999] focus:px-4 focus:py-2 focus:rounded-md focus:text-sm focus:font-medium focus:no-underline"
    >
      Skip to content
    </a>
  );
}
